import React from 'react';
import Form from 'antd/lib/form';
import InputNumber from 'antd/lib/input-number';
import 'antd/lib/input-number/style/index.css';
var InputCategoryCountMax = function (props) { return (React.createElement(Form.Item, { label: 'Category Count Max', colon: false }, props.form.getFieldDecorator('categoryCountMax', {
    initialValue: props.initialValue || 6,
    rules: [{
            type: 'integer',
        }],
})(React.createElement(InputNumber, { size: 'large', disabled: props.isDisabled })))); };
export default InputCategoryCountMax;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputCategoryCountMax.tsx
// module id = 1167
// module chunks = 0